import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {YzImgCropperComponent} from './yz-img-cropper/yz-img-cropper.component';
import {SharedModule} from "../shared.module";
import {LoadingModule} from "../loading/loading.module";


const COMPONENTS = [
  YzImgCropperComponent
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [...COMPONENTS],
  entryComponents: [...COMPONENTS],
  imports: [SharedModule, LoadingModule],
  exports: [...COMPONENTS]
})
export class ImgCropperModule {
}
